import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useTranslate } from 'react-polyglot';
import styles from './ExternalFaq.module.scss';
import backgroundImage from '../../../Assets/Images/background.svg';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { ExternalLayoutContext } from '../ExternalLayout';

function ExternalFaq() {
    const t = useTranslate();
    const [expanded, setExpanded] = useState<string | false>(false);
    const { setBackLink } = useOutletContext<ExternalLayoutContext>();

    useEffect(() => {
        setBackLink({ to: '/external', text: `← ${t("externalportal.page.backbutton")}` });
        return () => setBackLink(undefined);
    }, []);

    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const faqItems = [
        {
            id: 'faq1',
            question: t('externalportal.faq.q1.question'),
            answer: t('externalportal.faq.q1.answer')
        },
        {
            id: 'faq2',
            question: t('externalportal.faq.q2.question'),
            answer: t('externalportal.faq.q2.answer')
        },
        {
            id: 'faq3',
            question: t('externalportal.faq.q3.question'),
            answer: t('externalportal.faq.q3.answer')
        },
        {
            id: 'faq4',
            question: t('externalportal.faq.q4.question'),
            answer: t('externalportal.faq.q4.answer')
        },
        {
            id: 'faq5',
            question: t('externalportal.faq.q5.question'),
            answer: t('externalportal.faq.q5.answer')
        }
    ];

    return (
        <div 
            className={styles.puppyListings}
            style={{ '--background-image': `url(${backgroundImage})` } as React.CSSProperties}
        >
            <div className={styles.backgroundTail}></div>

            <div className={styles.mainContent}>
                <div className={styles.pageHeader}>
                    <div className={styles.headerRow}>
                        <h1>{t("externalportal.faq.header")}</h1>
                    </div>
                </div>

                <div className={styles.faqContent}>
                    {faqItems.map((item) => (
                        <Accordion 
                            key={item.id}
                            expanded={expanded === item.id} 
                            onChange={handleChange(item.id)}
                            className={styles.accordion}
                        >
                            <AccordionSummary
                                expandIcon={<span>▼</span>}
                                className={styles.accordionSummary}
                            >
                                <Typography className={styles.question}>{item.question}</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={styles.accordionDetails}>
                                <Typography className={styles.answer}>{item.answer}</Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>

            </div>
        </div>
    );
}

export default ExternalFaq;
